<template>
  <div class="no_data">
      <div>
        <img class="no_data_img" src="../../assets/img/no_data.png" alt="">
        <p class="p1">{{$t('main.text28')}}</p>
        <p class="p2">{{$t('main.text29')}}</p>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.no_data{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.p1{
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0.08em;
  color: #DEB981;
  margin-top: 28px;
  margin-bottom: 16px;
}
.p2{
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.8;
}
.no_data_img{
  width: 120px;
}
</style>